import {
  CreateItemConsumptionDTO,
  CreateReturnOrderDTO,
  CreateTransferJournalDTO,
  CreateTransferOrderDTO,
  Region2,
  UpdateStockDTO
} from '../api/api';
import WorkClient from '../api/workClient';

const getConsumedItems = (workTaskId: number) => {
  return WorkClient.getConsumedItems(workTaskId);
};

const getWarehouses = () => {
  return WorkClient.getWarehouses(Region2.OneERP);
};

const getOrdersWarehouses = () => {
  return WorkClient.getOrdersWarehouses();
};

const getAllDeliveryDropPoints = () => {
  return WorkClient.getAllDeliveryDropPoints();
};

const getItemsOnHand3 = (legalEntityId: string, warehouseId?: string, locationId?: string, itemId?: string) => {
  return WorkClient.getItemsOnHand3(legalEntityId, warehouseId, locationId, itemId, true);
};

const consumeItems = (body: CreateItemConsumptionDTO) => {
  return WorkClient.consumeItems(body);
};

const getEmergencyWarehouses = () => {
  return WorkClient.getEmergencyWarehouses();
};

const getJournalWarehouses = () => {
  return WorkClient.getJournalWarehouses();
};

const getActiveProducts = () => {
  return WorkClient.getAvailableProductsWithFavorites();
};

const getAllProducts = () => {
  return WorkClient.getAllProducts();
};

const createTransferOrder = (body?: CreateTransferOrderDTO) => {
  return WorkClient.createTransferOrder(body);
};

const createTransferJournal = (body: CreateTransferJournalDTO) => {
  return WorkClient.createTransferJournal(body);
};

const getActiveOrdersByWorkTask = (workTaskId: number) => {
  return WorkClient.getActiveOrdersByWorkTask(workTaskId);
};

const getActiveOrdersByWorkTaskAndUser = (workTaskId: number) => {
  return WorkClient.getActiveOrdersByWorkTaskAndUser(workTaskId);
};

const getActiveOrdersByUser = () => {
  return WorkClient.getActiveOrdersByUser();
};

const getTransferOrders = (warehouseId: string) => {
  return WorkClient.getActiveOrders(warehouseId);
};

const getTransferOrdersByWarehouse = (warehouseId: string) => {
  return WorkClient.getActiveOrdersByWarehouse(warehouseId);
};

const moveToVehicle = (orderId: number) => {
  return WorkClient.moveToVehicle(orderId);
};

const createItemMove = (consignorId: string) => {
  return WorkClient.createItemMove(consignorId);
};

const updateWarehouseStock = (legalEntityId: string, warehouseId: string, body: UpdateStockDTO[], locationId?: string) => {
  return WorkClient.updateWarehouseStock(legalEntityId, warehouseId, locationId, body);
};

const getAllowedDeliveryDates = (warehouseId: string) => {
  return WorkClient.getAllowedDeliveryDates(warehouseId);
};

const createReturnOrders = (body: CreateReturnOrderDTO) => {
  return WorkClient.createReturnOrder(body);
};

const getReturnOrders = (warehouseId: string) => {
  return WorkClient.geReturnOrders(warehouseId);
};

const checkIfWorkTaskHasConsumedItems = (workTaskId: number) => {
  return WorkClient.checkIfWorkTaskHasConsumedItemsOrTimeRegistrations(workTaskId);
};

const moveConsumedItemsToWorkInvoiceProject = (workInvoiceId: number) => {
  return WorkClient.moveItemsToWorkInvoiceProject(workInvoiceId);
};

const hasConsumedItemsToMove = (workInvoiceId: number) => {
  return WorkClient.hasConsumedItemsToMove(workInvoiceId);
};

const GoodsService = {
  getConsumedItems,
  getWarehouses,
  getOrdersWarehouses,
  getAllDeliveryDropPoints,
  getItemsOnHand3,
  consumeItems,
  getEmergencyWarehouses,
  getJournalWarehouses,
  getActiveProducts,
  getAllProducts,
  createTransferOrder,
  getActiveOrdersByWorkTask,
  getActiveOrdersByWorkTaskAndUser,
  getActiveOrdersByUser,
  createTransferJournal,
  getTransferOrders,
  createItemMove,
  updateWarehouseStock,
  getAllowedDeliveryDates,
  createReturnOrders,
  getReturnOrders,
  checkIfWorkTaskHasConsumedItems,
  moveConsumedItemsToWorkInvoiceProject,
  getTransferOrdersByWarehouse,
  moveToVehicle,
  hasConsumedItemsToMove
};

export default GoodsService;
